import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import ApiUser from '@/api/identityProvider/user'
import ApiRole from '@/api/identityProvider/role'

import RoleModel from '@/model/identity-provider/role'
import UserModel from '@/model/identity-provider/user'

export default {  
    mixins: [ FormMixin, DateMixin ], 
    data(){
        return {
            rules:{
                usuario: [
                    val => {
                        if((val || null) == null)
                            return this.ruleCodigoUnico;

                        return true;
                    }
                ]
            },
            lista:{
                user: [],
                role: []
            },
            user: new UserModel().returnModel()
        }
    }, 
    computed: {  
        title () {
            return this.$t('Views.ControleAcesso.Usuario.Listar.form-title')
        },
        labelUsuario(){
            return this.$t('Views.ControleAcesso.Usuario.Editar.usuario')
        },
        inputDescricao(){
            return this.$t('Views.ControleAcesso.Usuario.Editar.descricao')            
        },
        ruleCodigoUnico(){
            return this.$t('Views.ControleAcesso.Usuario.Editar.rule-codigo-unico')            
        },
        ruleDescricao(){
            return this.$t('Views.ControleAcesso.Usuario.Editar.rule-descricao')            
        }                                                     
    },
    methods:{
        async listarPerfil(){
            const resultado = await ApiRole.listar().catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                resultado.data.forEach(element => {
                    if(element.uniqueCode == 'PUBLIC')
                        element["checked"] = true;
                    else 
                        element["checked"] = false;
                });

                this.$set(this.lista, "role", resultado.data);
            }
        }
    }
}